import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmployeeLeaveManagementService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { }


  ESS_EmpLeaveDetailsOBLoad(LeaveMaster: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpLeaveDetails_OB_Select/Get`,
      this.session.SetClass(LeaveMaster)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  ESS_EmpLeaveDetailsOBUpdate(LeaveMaster: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpLeaveDetails_OB/Update`,
      this.session.SetClass(LeaveMaster)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  LeaveClosingBalance(Detail: any) {
    return this.http.post<any>('https://localhost:44352/' + `LeaveClosingBalance`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  LeaveClosingBalanceDetail(Detail: any) {
    return this.http.post<any>('https://localhost:44352/' + `EmpMonthlyLeaveCreditedInsert`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
